import {Badge} from 'antd';

import {FormattedDateTime} from '../../../provider/locale/formatted-date-time';
import {Locale} from '../../../provider/locale/locale';
import {useLocale} from '../../../provider/locale/locale-hook';
import {EventDetailType} from '../../../service/events/events-type';
import {
    PublicationPreviewInfo,
    PublicationPreviewRowType,
} from '../../publication-preview/info/publication-preview-info';
import {Text} from '../../text/text';
import {getEventAgeLabel, getEventStatusConfig, getEventTypeLangKey} from '../events-helper';

const DATE_TIME_OPTIONS: Intl.DateTimeFormatOptions = {
    hour: 'numeric',
    minute: 'numeric',
    day: 'numeric',
    month: 'numeric',
    year: 'numeric',
};

type PropsType = {
    event: EventDetailType;
    onClose: VoidFunction;
};

export function EventInfo({event, onClose}: PropsType): JSX.Element {
    const {getLocalizedString} = useLocale();

    const statusConfig = getEventStatusConfig(event.status);

    const rows: Array<PublicationPreviewRowType> = [
        {
            key: 'status',
            label: <Locale stringKey="POSTS__TABLE__STATUS" />,
            value: <Badge color={statusConfig.badgeColor} text={getLocalizedString(statusConfig.langKey)} />,
        },
        {
            key: 'type',
            label: <Locale stringKey="EVENTS__FORM__TYPE" />,
            value: <Locale stringKey={getEventTypeLangKey(event.eventType)} />,
        },
        {
            key: 'age',
            label: <Locale stringKey="EVENTS__FORM__AGE" />,
            value: <Text block>{getEventAgeLabel(event.minAge)}</Text>,
        },
        ...(event.startAt
            ? [
                  {
                      key: 'startAt',
                      label: <Locale stringKey="EVENTS__FORM__START_AT" />,
                      value: <FormattedDateTime options={DATE_TIME_OPTIONS} value={new Date(event.startAt)} />,
                  },
              ]
            : []),
        ...(event.finishAt
            ? [
                  {
                      key: 'finishAt',
                      label: <Locale stringKey="EVENTS__FORM__FINISH_AT" />,
                      value: <FormattedDateTime options={DATE_TIME_OPTIONS} value={new Date(event.finishAt)} />,
                  },
              ]
            : []),
        ...(event.publishAt
            ? [
                  {
                      key: 'publishAt',
                      label: <Locale stringKey="EVENTS__FORM__PUBLISH_AT" />,
                      value: <FormattedDateTime options={DATE_TIME_OPTIONS} value={new Date(event.publishAt)} />,
                  },
              ]
            : []),
    ];

    return (
        <PublicationPreviewInfo
            createdAt={event.createdAt}
            footer={
                event.description ? (
                    <div style={{display: 'flex', flexDirection: 'column', gap: 4}}>
                        <Text block secondary stringKey="EVENTS__PREVIEW__DESCRIPTION" />
                        <Text block>{event.description}</Text>
                    </div>
                ) : null
            }
            onClose={onClose}
            rows={rows}
            thumbnailUrl={event.images[0]?.url}
            title={event.title}
        />
    );
}
